<template>
  <div styleName="opt_footer">
    <select name="" styleName="opt_footer_toggle_line" v-model="sdkLine" @change="handleChange">
      <option value="1">line 1</option>
      <!-- <option value="2">line 2</option> -->
      <option value="3" disabled="disabled">line 3</option>
    </select>
    <div styleName="opt_footer_line" :style="{ width: $i18n.locale === 'zh' ? '80px' : '125px' }">
      <span styleName="opt_footer_line_title">{{ $t('teacher') }}</span>
      <span styleName="opt_footer_line_online">
        <span styleName="online" v-if="online">{{ $t('online') }}</span>
        <span styleName="offline" v-else>{{ $t('offline') }}</span>
      </span>
      <span styleName="opt_footer_line_icon" :data-offline="!online"></span>
    </div>
    <div styleName="opt_footer_audio" @click="handleAudio" :data-role="audioStatus + ''">
      <div v-if="audioStatus" styleName="opt_footer_audio_box" :style="audioBoxStyle"></div>
      <img styleName="opt_footer_audio_icon" src="../../assets/images/录音开启.png">
      <transition name="fade">
        <div class="fade-wp" styleName="opt_footer_audio_first_checked" v-if="audioStatus && (isAudioFistChecked || isAudioNotChecked)">{{ isAudioFistChecked ? $t('detectedVoice') : $t('failDetectingVoice') }}</div>
      </transition>
    </div>
    <wifi />
  </div>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import * as types from '../../constants'
import { mapGetters, mapActions } from 'vuex'
import Notice from '@/components/Notice'
import Wifi from './wifi.vue'
import getMediaEnterParams from '@/utils/getMediaEnterParams'
import { VENDOR } from "@/constants"
import { signalSdk, mediaSDK } from "@/utils/getSDK"
import sensorLog from '@/utils/sensorLog'
import { setTimeout } from 'timers';

export default {
  mixins: [CSSModules(styles)],
  data: function () {
    return {
      online: false,
      isvolume: true,
      noticeText: '',
      noticeShow: false,
      isAudioFistChecked: false,
      isOnce: false,
      isAudioNotChecked: false,
      availableNetwork: true,
      volume: 0,
      sdkLine: ''
    }
  },
  computed: {
    ...mapGetters(['audioLeval', 'audioStatus', 'roomDetail', 'enterMediaRoom', 'enterRoomParams', 'isPlayingVideo', 'cameraStatus', 'hasPublished']),
    audioBoxStyle () {
      return `height: ${Math.min(this.volume, 100)}%;`
    }
  },
  watch: {
    enterRoomParams (val) {
      if (val) {
        // this.sdkLine = VENDOR[val.roomType]
        this.sdkLine = val.roomType
        let enterParams = getMediaEnterParams(VENDOR[val.roomType])
        this.fetchMediaSDK(enterParams).catch((error) => {
          this.$toast.show({
            text: error,
            headerDesc: this.$t('attention'),
            buttonCount: 1,
            textStyle: {
              textAlign: 'center'
            },
            btnText: this.$t('btnok'),
            btnOK: () => {
              // 进入房间失败，切到声网
              this.updateClassLine('1')
              signalSdk.sendTransportData('1')
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          })
        })
      }
    },
    audioLeval: function (newData, oldData) {
      this.audioLevel = newData
    },
    cameraStatus: function (newData) {
      // let self = this
      // if (newData) {
      //   this.$eventSource.addListener('REALTIME_VOLUME', function (volume) {
      //     self.setVolume(volume)
      //   })
      // } else {

      // }
    },
    volume (val) {
      this.checkFirstVoiceTip(val)
    },
    '$store.getters.enterSignalRoom.data.status' (val) {
      if (val === 1) {
        this.online = true
      } else {
        this.online = false
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchMediaSDK',
      'exitMediaSDK',
      'updateClassLine'
    ]),
    handleAudio () {
      this.$store.commit(types.MEDIA_AUDIO_STATUS, !this.audioStatus)
      sensorLog.track("footer_audio_status", types.SENSORLOG.type.SUCCESSED, !this.audioStatus)
    },
    async handleChange (e) {

      if (this.enterMediaRoom.data.status && this.enterMediaRoom.data.status === 1) {
        if (this.hasPublished) {
          await mediaSDK.unpublishMedialStream()
          await mediaSDK.closeMedial()
        }
        // 切换到agora
        this.exitMediaSDK()
        let enterParams = getMediaEnterParams(VENDOR[this.sdkLine])

        await this.fetchMediaSDK(enterParams)
          .then(() => {
            this.updateClassLine(this.sdkLine)
            signalSdk.sendTransportData(this.sdkLine)
          })
          .catch((err) => {
            this.$toast.show({
              text: 'toggleLine failed,the reason is :' + err,
              headerDesc: this.$t('attention'),
              buttonCount: 1,
              textStyle: {
                textAlign: 'center'
              },
              btnText: this.$t('btnok'),
              btnOK: () => {
                // 切线失败，切到声网
                this.updateClassLine('1')
                signalSdk.sendTransportData('1')

                setTimeout(() => {
                  window.location.reload()
                }, 1000)
              }
            })
          })
      }

      // // 已经进入房间
      // if (this.sdkLine === '1' || this.sdkLine === '3') {

      // }
      // else if (this.sdkLine === '2') {
      //   setTimeout(() => {
      //     window.location.reload()
      //     // 如果视频在播放中 先关闭视频
      //     this.isPlayingVideo === 2 && signalSdk.sendCloseVideoMP4()
      //   }, 1000)
      // }
    },
    checkNoVoiceTip () {
      let outerTimer = setInterval(() => {
        if (this.isOnce) {
          clearInterval(outerTimer)
        } else {
          this.isAudioNotChecked = true
          let innerTimer = setTimeout(function () {
            this.isAudioNotChecked = false
            clearTimeout(innerTimer)
          }, 3 * 1000)
        }
      }, 10 * 1000)
    },
    checkFirstVoiceTip (val) {
      if (val > 10 && !this.isOnce) {
        this.isOnce = true
        this.isAudioFistChecked = true
        this.isAudioNotChecked = false
        let timer = setTimeout(() => {
          this.isAudioFistChecked = false
          clearTimeout(timer)
        }, 3000)
      }
    },
    showNotice (text) {
      this.noticeText = text
      this.noticeShow = true
      setTimeout(() => {
        this.noticeShow = false
      }, 2000)
    },
    setVolume (volume) {
      this.volume = volume
    }
  },
  beforeDestroy () {
    let self = this
    this.$eventSource.reomoveListener('REALTIME_VOLUME', function (volume) {
      self.setVolume(volume)
    })
  },
  mounted () {
    let self = this

    this.$eventSource.addListener('REALTIME_VOLUME', function (volume) {
      self.setVolume(volume)
    })

    this.checkNoVoiceTip()
    // 异常事件监听
    window.addEventListener('offline', () => {
      this.online = false
      // this.$toast.show({
      //   header: false,
      //   headerDesc: this.$t('attention'),
      //   text: this.$t('disconnected'),
      //   buttonCount: 1,
      //   btnText: this.$t('btnok'),
      //   textStyle: {
      //     'text-align': 'center'
      //   }
      // })
      sensorLog.track("footer_tacher_offline", types.SENSORLOG.type.FAILED)
    })
    window.addEventListener('online', () => {
      sensorLog.track("footer_tacher_online", types.SENSORLOG.type.SUCCESSED)
      this.online = true
      window.location.reload()
    })
  },
  components: {
    Notice,
    Wifi
  }
}
</script>
